import {
	DialogResultOutput,
	ProductHotel,
	ProductOrganizationDialogConfig,
	ProductOrganizationTableTemplate,
} from '@/products/product/product.model';
import { DatePipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, computed, inject, input, output } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDialog } from '@angular/material/dialog';
import { MatTableModule } from '@angular/material/table';
import { filter } from 'rxjs';
import { ProductDynamicFormDialogComponent } from '../product-dynamic-form-dialog/product-dynamic-form-dialog.component';

@Component({
	selector: 'app-product-mat-table-template',
	standalone: true,
	imports: [MatTableModule, DatePipe, MatButtonModule],
	template: `
		@if (dataSource().length > 0) {
			<table mat-table [dataSource]="dataSource()">
				@for (item of tableTemplate(); track item.key) {
					@switch (item.key) {
						@case ('createdBy') {
							<ng-container matColumnDef="createdBy">
								<th mat-header-cell *matHeaderCellDef>Utworzone przez</th>
								<td mat-cell *matCellDef="let element">
									{{ element.createdBy?.firstName }} {{ element.createdBy?.lastName }}
								</td>
							</ng-container>
						}
						@case ('createdAt') {
							<ng-container matColumnDef="createdAt">
								<th mat-header-cell *matHeaderCellDef>Utworzone</th>
								<td mat-cell *matCellDef="let element">
									{{ element.createdAt | date: 'dd.MM.yyyy, HH:mm' }}
								</td>
							</ng-container>
						}
						@case ('www') {
							<ng-container matColumnDef="www">
								<th mat-header-cell *matHeaderCellDef>WWW</th>
								<td mat-cell *matCellDef="let element">
									<a target="_blank" [href]="element.www" rel="noreferrer nofollow">{{
										element.www
									}}</a>
								</td>
							</ng-container>
						}
						@case ('url') {
							<ng-container matColumnDef="url">
								<th mat-header-cell *matHeaderCellDef>Url</th>
								<td mat-cell *matCellDef="let element">
									<a target="_blank" [href]="element.url" rel="noreferrer nofollow">{{
										element.url
									}}</a>
								</td>
							</ng-container>
						}
						@case ('edit') {
							<ng-container matColumnDef="edit">
								<th mat-header-cell *matHeaderCellDef></th>
								<td class="text-end" mat-cell *matCellDef="let element">
									<button (click)="openEditDialog(element)" mat-icon-button color="primary">
										<i class="fas fa-edit"></i>
									</button>
								</td>
							</ng-container>
						}
						@case ('destination') {
							<ng-container [matColumnDef]="item.key">
								<th mat-header-cell *matHeaderCellDef>{{ item.label }}</th>
								<td mat-cell *matCellDef="let element">
									{{ element[item.key]?.name }}
								</td>
							</ng-container>
						}
						@default {
							<ng-container [matColumnDef]="item.key">
								<th mat-header-cell *matHeaderCellDef>{{ item.label }}</th>
								<td mat-cell *matCellDef="let element">
									{{ element[item.key] }}
								</td>
							</ng-container>
						}
					}
				}

				<tr mat-header-row *matHeaderRowDef="displayedColumns()"></tr>
				<tr mat-row *matRowDef="let row; columns: displayedColumns()"></tr>
			</table>
		} @else {
			<div class="alert alert-warning text-center" role="alert">Brak danych</div>
		}
	`,
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ProductMatTableTemplateComponent {
	readonly dataSource = input.required<ProductHotel[]>();
	readonly tableTemplate = input.required<ProductOrganizationTableTemplate[]>();
	readonly dialogConfig = input.required<ProductOrganizationDialogConfig>();

	readonly emitEditDialogResult = output<DialogResultOutput>();

	readonly displayedColumns = computed(() => this.tableTemplate().map((i) => i.key));

	private readonly matDialog = inject(MatDialog);

	openEditDialog(itemToEdit: { id: number } & unknown): void {
		this.matDialog
			.open(ProductDynamicFormDialogComponent, {
				data: {
					...this.dialogConfig(),
					fields: this.dialogConfig().fields.map((field) => ({
						...field,
						initialValue: itemToEdit[field.key as keyof typeof itemToEdit],
					})),
				},
				width: '520px',
				autoFocus: true,
				restoreFocus: true,
				disableClose: true,
			})
			.afterClosed()
			.pipe(filter(Boolean))
			.subscribe((result) => {
				result[this.dialogConfig().configType] = {
					...result[this.dialogConfig().configType],
					id: itemToEdit.id,
				};

				this.emitEditDialogResult.emit(result);
			});
	}
}
